import React from 'react'
import { useTranslation } from 'react-i18next'
import { BEILAGE_OPTION_TYPE, COLOR_NAME, COMMON_STATUS } from '../../../constants'
import { clsx, ensureArray } from '../../../utils/helper'
import Checkbox from '../../elements/Checkbox'
import FormatCurrency from '../../elements/FormatCurrency';

const GroupTopping = ({
    className = '',
    item = {},
    listChecked = [],
    handleChangeTopping,
    setMoreInfo
}) => {
    const { t } = useTranslation();

    const { food_datas, type } = item;

    const handleViewMoreInfo = (e, info) => {
        e.stopPropagation()
        e.preventDefault()

        setMoreInfo(info);
    }

    return (
        <div className={`list-topping ${className}`}>
            <div className="list-topping--title label-2">
                {item.group_name}
            </div>

            <div className="list-topping__list">
                {ensureArray(food_datas).map((tp, index) => {
                    const addable = tp.status === COMMON_STATUS.ACTIVE;
                    return (
                        <div
                            key={index}
                            onClick={() => addable && handleChangeTopping(index)}
                            className={clsx('topping-item flex-between label-2', !addable && 'disabled')}
                        >
                            <div className="topping-item--name">
                                <Checkbox
                                    square={type === BEILAGE_OPTION_TYPE.MULTI}
                                    checked={(listChecked || [])[index]}
                                />
                                <span className="value">{tp.name_food}</span>
                                {tp.productInfo && (
                                    <span
                                        onClick={e => handleViewMoreInfo(e, tp.productInfo)}
                                        className="label-3 ml-2 primary-color"
                                    >
                                        {t('button.moreInfo')}
                                    </span>
                                )}
                            </div>
                            {!!tp.price && (
                                <div className="topping-item--price">
                                    +<FormatCurrency amount={tp.price} />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default GroupTopping
